__turbopack_context__.v({
  "actions": "ObjectiveEmpty-module__xQQjla__actions",
  "card": "ObjectiveEmpty-module__xQQjla__card",
  "content": "ObjectiveEmpty-module__xQQjla__content",
  "description": "ObjectiveEmpty-module__xQQjla__description",
  "examples": "ObjectiveEmpty-module__xQQjla__examples",
  "examplesLabel": "ObjectiveEmpty-module__xQQjla__examplesLabel",
  "iconContainer": "ObjectiveEmpty-module__xQQjla__iconContainer",
  "title": "ObjectiveEmpty-module__xQQjla__title",
});
